<template>
  <div class="top">
    <section id="header" class="set-margin dash-header">
      <div class="mobileHeader navigation home-container-header">
        <nav class="navbar navbar-light navbar-expand-lg">
          <a class="MobileHeader__button" role="button">
            <div @click="this.$store.state.mobileSidebarOpen = !this.$store.state.mobileSidebarOpen" v-if="this.$store.getters.getisAuth" class="Avatar__wrapper">
              <img :src="`${this.$store.getters.get_profile_img}`" class="Avatar">
            </div>
          </a>
          <router-link to="/" target="_self" class="navbar-brand">
            <img class="HeaderTitle__logo" src="@/assets/logo.svg">
          </router-link>
        </nav>
      </div>
      <div class="desktopHeader navigation home-container-header">
        <nav class="navbar navbar-light navbar-expand-lg">
          <router-link to="/" target="_self" class="navbar-brand">
            <img id="logo" src="@/assets/logo.svg">
          </router-link>
          <div id="nav-collapse" class="navbar-collapse collapse">
            <ul id="navbar-parent" class="navbar-nav ml-auto align-items-center">
              <div v-if="this.$store.getters.getisAuth" class="Menu Menu--open-downwards Menu--white UserMenu">
                <div @click="this.MenuisDisplay = !this.MenuisDisplay" class="UserMenu__handler" id="Menu_panel">
                  <div class="Avatar__wrapper">
                    <img :src="`${this.$store.getters.get_profile_img}`" class="ImageLoader Avatar">
                  </div>
                  <div class="Nickname">
                    <div class="Nickname__wrapper">
                      <span class="Nickname__span">{{ this.$store.getters.get_profile_nickname }}</span>
                    </div>
                  </div>
                  <span class="Menu__handle Menu__handle--dropdown"></span>
                </div>
                <transition>
                  <div v-show="MenuisDisplay" class="Menu__panel Menu__panel--no-arrow">
                    <ul class="Menu__panel__ul">
                      <li>
                        <router-link to="/profile" class="Menu__panel__ul__a Menu__panel__li__profile">
                          <div class="Avatar__wrapper">
                            <img :src="`${this.$store.getters.get_profile_img}`" class="ImageLoader Avatar">
                          </div>
                          <div>
                            <h4>{{ this.$store.getters.get_profile_nickname }}</h4>
                            <p>プロフィールを見る</p>
                          </div>
                        </router-link>
                      </li>
                      <li>
                        <router-link to="/subscription" class="Menu__panel__ul__a">
                          <img class="Menu__panel__ul__a__icon" src="@/assets/icon/iconizer-description-fill0-wght400-grad0-opsz24.svg">契約情報</router-link>
                      </li>
                      <li>
                        <router-link to="/settings" class="Menu__panel__ul__a">
                          <img class="Menu__panel__ul__a__icon" src="@/assets/icon/icon-cog.svg">設定</router-link>
                      </li>
                      <hr class="divider">
                      <li>
                        <router-link to="/logout" class="Menu__panel__ul__a">
                          <img class="Menu__panel__ul__a__icon" src="@/assets/icon/icon-exit.svg">ログアウト</router-link>
                      </li>
                    </ul>
                  </div>
              </transition>
              </div>
            </ul>
          </div>
        </nav>
      </div>
    </section>
    <div v-if="otherAuthError" class="ng-star-inserted">
      <div
        class="xap-callout">
        <img class="material-icons" src="@/assets/icon/help_FILL0_wght400_GRAD0_opsz48.svg">
        <div class="xap-callout-content-and-actions">
          <div class="xap-callout-content">
            <div class="xap-callout-body">
              連携が正常ではないものがございます。各種設定から連携に関する設定と連携の確認をしてください。
            </div>
          </div>
          <div class="xap-callout-actions">
            <button class="dismiss-button" @click="outherTokenError_Close ()">
              閉じる
            </button>
            <button class="announcement-link" @click="SettingoutherTokens_Go ()">
              連携設定を確認
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      MenuisDisplay: false
    }
  },
  computed: {
    mobile () {
      return this.$store.state.mobile
    },
    otherAuthError () {
      return this.$store.getters.getotherAuthError
    }
  },
  mounted () {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.UserMenu__handler')) {
        this.MenuisDisplay = false
      }
    })
  },
  methods: {
    outherTokenError_Close () {
      this.$store.commit('set_otherAuthError', false)
    },
    SettingoutherTokens_Go () {
      this.$store.commit('set_otherAuthError', false)
      this.$router.push({ name: 'settings' })
    }
  }
}
</script>

<style lang='scss'>
.top {
  user-select: none;

  #header {
    background-color: #fff;
    border-bottom: 1px solid #dee3ea;
    z-index: 999;

    @media (min-width: 1201px) {
      .mobileHeader {
          display: none;
      }
    }

    @media (max-width: 1200px) {
      .desktopHeader {
          display: none;
      }
    }

    .mobileHeader {
      margin: 10px 0;

      .navbar {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 20px;

        .MobileHeader__button {
          display: contents;
          cursor: pointer;

          .Avatar__wrapper {
            display: flex;
            align-items: center;
            position: absolute;
            left: 0;

            .Avatar {
              width: 42px;
              height: 42px;
              border-radius: 50%;
              background-color: #f4f4f4;
              object-fit: cover;
            }
          }
        }
        .navbar-brand {
          display: block;
          width: 170px;
          margin: 0 auto;

          .HeaderTitle__logo {
            width: 170px;
            height: auto;
          }
        }
      }
    }

    .desktopHeader {
      .navbar {
        display: flex;
        position: relative;
        padding: 0.5rem 1rem;

        .navbar-brand {
          display: flex;
          align-items: center;

          #logo {
            height: auto;
            width: 165px;
          }

          #logo.mobile {
            height: auto;
            width: 60%;
            max-width: 200px;
          }
        }

        .navbar-collapse {
          display: flex;
          flex-basis: auto;
          flex-basis: 100%;
          flex-grow: 1;
          align-items: center;

          .ml-auto {
            margin-left: auto;
          }

          .nav-item {
            font-size: 15px;
            line-height: 20px;
            text-align: left;
            color: #3f3939;

            .nav-link {
              display: block;
              padding: 0.5rem 1rem;
            }

            .top-navbar-link {
              padding-left: 15px;
              padding-right: 15px;
            }
          }

          .UserMenu {

            margin-left: 20px;

            ul {
              list-style-type: none;
            }

            .UserMenu__handler {
              display: flex;
              position: relative;
              grid-gap: calc(20px * 0.5);
              align-items: center;
              height: 100%;
              cursor: pointer;

              .Avatar__wrapper {
                position: relative;
                width: auto;
                height: auto;
                border-radius: inherit;

                .ImageLoader {
                  width: 35px;
                  height: 35px;
                  border-radius: 50%;
                }
              }

              .Nickname {
                max-width: 200px;

                .Nickname__wrapper {
                  display: inline-grid;
                  grid-gap: 5px;
                  grid-gap: calc(20px * 0.25);
                  grid-template-columns: 1fr -webkit-max-content;
                  grid-template-columns: 1fr max-content;
                  align-items: center;

                  .Nickname__span {
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }

              .Menu__handle {
                display: flex;
                box-sizing: content-box;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                transition: transform .4s;
                outline: none;
                cursor: pointer;
                will-change: transform;
              }

              .Menu__handle:before {
                content: "";
                display: block;
                width: 10px;
                height: 10px;
                background-size: 10px px;
              }

              .Menu__handle:before {
                content: "";
                display: block;
                width: 6px;
                height: 19px;
                background-image: url(@/assets/icon/icon-timeline-item-handle.svg);
                background-repeat: no-repeat;
                background-position: 50%;
                background-size: contain;
              }
            }

            .Menu__panel {
              position: absolute;
              z-index: 9000;
              bottom: -5px;
              transform: none;
              opacity: 1;
              color: #212121;
              pointer-events: auto;
              will-change: opacity, transform;
              top: calc(100% + 10px);
              right: 25px;
              color: #888;

              &.v-enter-active {
                animation: fadeIn .4s ease 0s 1 normal backwards;
              }

              @keyframes fadeIn {
                from {
                  opacity: 0;
                  transform: translateY(-15px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }

              .Menu__panel__ul {
                position: relative;
                z-index: 2000;
                padding: 6px 0;
                padding: calc(20px * 0.3) 0;
                border-radius: 5px;
                background-color: #f9f9f9;
                box-shadow: 0 1px 4px 0 rgb(0 0 0 / 29%);
                padding: 0;

                a {
                  color: currentcolor;
                  text-decoration: none;
                  cursor: pointer;
                }

                .Menu__panel__li__profile {
                  grid-gap: 16px;
                  gap: 16px;

                  h4 {
                    color: #212121;
                    font-weight: 700;
                  }

                  .Avatar__wrapper {
                    position: relative;
                    width: 56px;
                    min-width: 56px;
                    height: 56px;
                    border-radius: inherit;

                    .ImageLoader {
                      background-color: #f4f4f4;
                      object-fit: cover;
                      width: 100%;
                      height: 100%;
                    }

                    .Avatar {
                      border-radius: 50%;
                    }
                  }
                }

                .Menu__panel__ul__a {
                  display: flex;
                  align-items: center;
                  grid-gap: 8px;
                  gap: 8px;
                  padding: calc(20px * 0.8);
                  min-width: 170px;
                  transition: border-color .4s, background-color .4s;
                  text-align: left;
                  white-space: nowrap;
                  will-change: border-color, background-color;

                  .Menu__panel__ul__a__icon {
                    width: 18px;
                    height: 18px;
                  }
                }
              }

              .Menu__panel__ul>:not(:last-child) {
                border-bottom: 1px solid #bcbcbc;
              }
            }
          }
        }

        .navbar-collapse.mobile {
          display: none;
        }
      }
    }
  }

  @media (max-width: 1200px) {
    .ng-star-inserted {
      top: 66.13px!important;
    }
  }

  .ng-star-inserted {
    position: fixed;
    top: 58.4px;
    width: 100%;
    border: 1px solid #e1e1e1;
    z-index: 999;

    .xap-callout {
      display: flex;
      align-items: center;
      background-color: #ffe6e6;
      box-sizing: border-box;
      color: #3c4043;
      overflow-wrap: anywhere;
      padding: 6px 16px 6px 8px;

      .material-icons {
        margin-left: 16px;
        color: #d93025;
        user-select: none;
        background-repeat: no-repeat;
        display: inline-block;
        fill: currentColor;
        height: 24px;
        width: 24px;
      }

      @media (max-width: 700px) {
        .xap-callout-content-and-actions {
          display: block!important;
        }
      }

      .xap-callout-content-and-actions {
        display: flex;
        flex-wrap: nowrap;
        -webkit-box-pack: justify;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #3c4043;
        overflow-wrap: anywhere;

        .xap-callout-content {
          flex: 1 1 60ch;
          padding: 0 8px 0 16px;

          .xap-callout-body {
            font-size: 14px;
            font-weight: bold;
            line-height: 20px;
            letter-spacing: .2px;
          }
        }

        .xap-callout-actions {
          display: flex;
          align-items: center;

          button {
            background: none;
            margin: 6px 8px;
            appearance: none;
            border: 0;
            border-radius: 4px;
            cursor: pointer;
          }

          .dismiss-button {
            padding: 6px 8px;
            color: #d93025;
            width: 56px;

            &:hover {
              background: rgba(95,99,104,.1);
            }
          }

          .announcement-link {
            padding: 6px 24px;
            background: #d93025;
            color: #fff;
            width: 141.32px;
            transition: all 0.2s ease;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.12);
            &:hover {
              background-color: #ea4a54;
              box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15), 0 1px 3px rgba(0, 0, 0, 0.1);
            }
          }
        }
      }
    }
  }

  .dash-header {
    position: fixed;
    top: 0;
    width: 100%;

    .navigation {
      z-index: 2;
      position: relative;
      width: 100%;
      margin: 0 auto;
      padding: 1px;
    }
  }

  .align-items-center {
    align-items: center;
  }

  .navbar-nav {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }

  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }

  a {
    text-decoration: none;
  }

  .navbar-light .navbar-nav .nav-link {
    color: rgba(0, 0, 0, .5);
  }

}
</style>
